import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { FormControlLabel, Checkbox, MenuItem, Select, FormControl } from "@material-ui/core";
import { TextInput } from "../../../FlowConfigurationInputs/TextInput/NewTextInput";

export default function Delete({ action, variables, setOpenVariable }) {
  const [sizeType, setSizeType] = useState("");
  const [checked, setChecked] = useState(false);
  const { t } = useTranslation();
  const label = "CONTENT.CONFIGURATION-FORM.FOLDER.";
  const label_file = "CONTENT.CONFIGURATION-FORM.FILE.";

  //action field is control default value
  useEffect(() => {
    if (!action.fields.sizeType) {
      action.fields.sizeType = { value: "" };
    } else {
      if (action.fields.sizeType.value?.length > 0) {
        setChecked(true);
      }
      setSizeType(action.fields.sizeType.value);
    }
    if (!action.fields.size?.value) {
      action.fields.size = { value: "" };
    }
  }, [action, variables]);

  // set select Size type
  function handleSizeTypeChange(e) {
    setSizeType(e.target.value);
    action.fields.sizeType.value = e.target.value;
  }

  // select input is a change assign object value
  function handleChangeSize(event) {
    setChecked(!checked);
    if (!event.target.checked) {
      action.fields.sizeType.value = "";
      action.fields.size.value = "";
      action.fields.size.htmlValue = "";
      action.fields.size.isRequired = false;
    } else {
      action.fields.size.isRequired = true;
    }
  }

  return (
    <div>
      <div className="form-element">
        {t(label + "FOLDER")}
        <TextInput
          action={action}
          inputName="folderPath"
          variables={variables}
          setOpenVariable={setOpenVariable}
          isRequired={true}
          extractPath="folder"
          fieldType="string"
          displayName={t(label + 'FOLDER')}
        />
      </div>
      <div className="form-element">
        <FormControlLabel
          control={
            <Checkbox
              checked={checked}
              onChange={handleChangeSize}
              name="size"
              color="#C4C4C4"
              size="small"
            />
          }
          label={t(label_file + "SIZE")}
        />
        <div className="form-element">
          <FormControl variant="outlined" disabled={!checked} fullWidth style={{ width: "90%" }}>
            <Select value={sizeType} onChange={handleSizeTypeChange}>
              <MenuItem value="atleast">{t(label_file + "ATLEAST")}</MenuItem>
              <MenuItem value="atmost">{t(label_file + "ATMOST")}</MenuItem>
              <MenuItem value="exact">{t(label_file + "EXACT")}</MenuItem>
            </Select>
          </FormControl>
          <div
            className="form-element"
            style={{ pointerEvents: !checked && "none" }}
          >
            <span style={{ color: !checked && "var(--manatee)" }}>
              {t(label_file + "SIZE")}(KB){" "}
            </span>
            <TextInput
              action={action}
              inputName="size"
              variables={variables}
              setOpenVariable={setOpenVariable}
              isRequired={checked}
              fieldType="number"
              displayName={t(label + 'SIZE')}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
